import type { ExternalFormData, Form360Data, StandardFormData } from "../../../../../../components/FormSelectionCard";

export const FORM_TYPES = ["standard", "360", "external"] as const;
export type FormType = (typeof FORM_TYPES)[number];

export type FormDataByType = {
	standard: StandardFormData;
	"360": Form360Data;
	external: ExternalFormData;
};

export type ConfiguredForm<T extends FormType = FormType> = {
	/** Local UUID — React key + delete handle. */
	localId: string;
	/** Backend review-form id this card represents. */
	formId: string;
	/** True when the form was added by selecting a review template. */
	fromTemplate: boolean;
	/** Form configuration values, validated by the matching schema. `data.formName` is the source of truth for the form name. */
	data: FormDataByType[T];
};

export type FormsByType = {
	[K in FormType]: ConfiguredForm<K>[];
};

export type SelectedTemplate = { id: string; name: string };

export type AddFormsStepData = {
	selectedTemplate: SelectedTemplate | null;
	forms: FormsByType;
};
